import React from 'react';
import { SIT_OUT_COPY } from '../../utils/sitOutCopy';
import InkSwitch from '../ui/InkSwitch';

// Host setting: Away players pay blinds. Default off (skip + owe).
// Game settings sheet + Change blinds (Host tools → Blinds). Next hand.

export default function AwayBlindsToggle({
  enabled = false,
  onChange,
  disabled = false,
  hideLabel = false,
}) {
  return (
    <InkSwitch
      enabled={enabled}
      onChange={onChange}
      disabled={disabled}
      hideLabel={hideLabel}
      label={SIT_OUT_COPY.toggleLabel}
      ariaLabel={SIT_OUT_COPY.toggleLabel}
      testId="away-blinds-toggle"
    />
  );
}
